/* eslint max-len: 0 */
import React from "react";
import PropTypes from "prop-types";

const ORIGINAL_WIDTH = 135.679;
const ORIGINAL_HEIGHT = 14.02;

function SVG({ scale }) {
    const width = ORIGINAL_WIDTH * scale;
    const height = ORIGINAL_HEIGHT * scale;
    const widthString = `${width}px`;
    const heightString = `${height}px`;

    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={widthString}
            height={heightString}
            viewBox={`0 0 ${ORIGINAL_WIDTH} ${ORIGINAL_HEIGHT}`}
            enableBackground={`new 0 0 ${ORIGINAL_WIDTH} ${ORIGINAL_HEIGHT}`}
        >
            <g>
                <path stroke="#1B1C20" d="M7.279,13.52c2.239,0,3.92-0.379,5.04-1.141c1.119-0.76,1.68-1.752,1.68-2.979 c0-1.053-0.423-1.857-1.27-2.41c-0.848-0.553-2.057-0.957-3.631-1.211l-2.1-0.34C5.372,5.188,4.56,4.793,4.56,4.26 c0-0.666,0.812-1,2.439-1c0.934,0,1.833,0.141,2.7,0.42s1.553,0.641,2.06,1.08l1.58-2.459C11.859,1.1,9.792,0.5,7.14,0.5 c-2.014,0-3.561,0.363-4.641,1.09S0.88,3.268,0.88,4.439c0,1.961,1.553,3.213,4.659,3.76l2.32,0.4 c0.84,0.146,1.437,0.291,1.79,0.43c0.353,0.141,0.529,0.344,0.529,0.611c0,0.346-0.213,0.623-0.64,0.83s-1.04,0.309-1.84,0.309 c-1.08,0-2.106-0.16-3.08-0.479C3.646,9.98,2.826,9.572,2.159,9.08l-1.5,2.6c0.707,0.508,1.641,0.939,2.8,1.301 C4.619,13.34,5.892,13.52,7.279,13.52z" />
                <polygon stroke="#1B1C20" points="24.358,13.279 29.539,0.74 25.72,0.74 22.259,10.48 18.879,0.74 14.899,0.74 19.919,13.279" />
                <rect x="31.679" y="0.74" stroke="#1B1C20" width="3.561" height="12.539" />
                <path stroke="#1B1C20" d="M45.759,10.6h-2.92V8.141h2.74V5.879h-2.74V3.42h3.08c1.053,0,1.873,0.303,2.46,0.91 s0.88,1.51,0.88,2.709c0,1.201-0.312,2.094-0.939,2.682C47.692,10.307,46.839,10.6,45.759,10.6z M46.239,13.279 c1.906,0,3.496-0.543,4.77-1.629c1.273-1.088,1.91-2.623,1.91-4.611c0-1.092-0.178-2.049-0.53-2.869s-0.847-1.477-1.479-1.971 c-0.633-0.492-1.36-0.859-2.18-1.1c-0.82-0.24-1.738-0.359-2.75-0.359h-6.701v5.139h-1.5v2.262h1.5v5.139H46.239z" />
                <path stroke="#1B1C20" d="M61.299,3.539l1.96,5.102h-3.98L61.299,3.539z M64.879,13.279h3.979L63.599,0.74h-4.4l-5.359,12.539 h3.779l0.801-2.26h5.68L64.879,13.279z" />
                <polygon stroke="#1B1C20" points="92.639,13.279 92.639,0.74 87.239,0.74 84.159,9.959 80.858,0.74 75.458,0.74 75.458,13.279 79.019,13.279 79.019,4.359 82.198,13.279 85.919,13.279 89.079,4.359 89.079,13.279" />
                <rect x="96.318" y="0.74" stroke="#1B1C20" width="3.56" height="12.539" />
                <path stroke="#1B1C20" d="M113.839,13.52c2.24,0,3.92-0.379,5.039-1.141c1.121-0.76,1.681-1.752,1.681-2.979 c0-1.053-0.423-1.857-1.271-2.41c-0.847-0.553-2.057-0.957-3.63-1.211l-2.1-0.34c-1.628-0.252-2.44-0.646-2.44-1.18 c0-0.666,0.812-1,2.44-1c0.933,0,1.833,0.141,2.7,0.42s1.553,0.641,2.06,1.08l1.58-2.459c-1.479-1.201-3.547-1.801-6.2-1.801 c-2.013,0-3.561,0.363-4.64,1.09c-1.08,0.727-1.62,1.678-1.62,2.85c0,1.961,1.553,3.213,4.66,3.76l2.32,0.4 c0.84,0.146,1.437,0.291,1.789,0.43c0.354,0.141,0.53,0.344,0.53,0.611c0,0.346-0.213,0.623-0.64,0.83 c-0.428,0.207-1.04,0.309-1.84,0.309c-1.08,0-2.107-0.16-3.08-0.479c-0.973-0.32-1.793-0.729-2.461-1.221l-1.5,2.6 c0.707,0.508,1.641,0.939,2.801,1.301C111.179,13.34,112.451,13.52,113.839,13.52z" />
                <polygon stroke="#1B1C20" points="135.179,13.279 135.179,10.439 126.759,10.439 126.759,8.279 132.998,8.279 132.998,5.721 126.759,5.721 126.759,3.58 134.778,3.58 134.778,0.74 123.198,0.74 123.198,13.279" />
            </g>
        </svg>
    );
}

export default SVG;

SVG.propTypes = {
    scale: PropTypes.number,
};

SVG.defaultProps = {
    scale: 1,
};
